"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _cdnHostnames = require("../utils/cdnHostnames");

var QaCdnHostnames = ['cdn2.hubspotqa.com', //redirecting to cdn2.hubspotqa.net
'cdn2.hubspotqa.net'].concat((0, _toConsumableArray2.default)((0, _cdnHostnames.generateCdnHostnames)('qa')));
var ProdCdnHostnames = ['cdn2.hubspot.net'].concat((0, _toConsumableArray2.default)((0, _cdnHostnames.generateCdnHostnames)('prod')));
var CdnHostnames = [].concat((0, _toConsumableArray2.default)(QaCdnHostnames), (0, _toConsumableArray2.default)(ProdCdnHostnames));
var _default = CdnHostnames;
exports.default = _default;
module.exports = exports.default;